/**
 * Saví Sava — theme patches (added 22 Sep 2026)
 *
 * Two fixes live here. Both are patches on top of the Horizon theme; each
 * block says what it fixes and how to make it permanent at the source.
 */
(function () {
  /* ----------------------------------------------------------------------
   * 1. Wishlist button label
   *
   * The heart buttons on product cards are created by the inline script in
   * the announcement-bar custom Liquid (sections/header-group.json), which
   * labelled them in German ("Zu Favoriten hinzufuegen"). The store is
   * US-facing and English throughout, and screen readers read that label out
   * loud. Also keeps the label in sync with the saved/unsaved state, which
   * the original script never did.
   * -------------------------------------------------------------------- */
  var SAVED = 'Remove from favorites';
  var UNSAVED = 'Add to favorites';

  function relabel(button) {
    var isSaved =
      button.classList.contains('is-liked') ||
      button.getAttribute('aria-pressed') === 'true' ||
      button.getAttribute('data-active') === 'true';
    var wanted = isSaved ? SAVED : UNSAVED;
    if (button.getAttribute('aria-label') !== wanted) {
      button.setAttribute('aria-label', wanted);
    }
  }

  function relabelAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('.savi-wishlist-btn, .wishlist-btn, [data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) relabel(buttons[i]);
  }

  /* ----------------------------------------------------------------------
   * 2. Payment icons in the cart
   *
   * cart-summary.liquid pipes the whole shop.enabled_payment_types array
   * into payment_type_svg_tag, which expects a single type — so the drawer
   * shows one grey "Generic" card. snippets/stylesheets.liquid renders the
   * real icons into <template id="savi-payment-icons">; this moves them in.
   *
   * On the cart page the theme renders no payment row at all, so the row is
   * created under the trust badges. Centering is handled in savi-fixes.css.
   * -------------------------------------------------------------------- */
  function paymentIconsHtml() {
    var template = document.getElementById('savi-payment-icons');
    if (!template || !template.content) return '';
    var holder = document.createElement('div');
    holder.appendChild(template.content.cloneNode(true));
    return holder.innerHTML.trim();
  }

  function expectedIconCount() {
    var template = document.getElementById('savi-payment-icons');
    if (!template || !template.content) return 0;
    return template.content.querySelectorAll('svg').length;
  }

  function fixPaymentIcons(root) {
    var html = paymentIconsHtml();
    if (!html) return;
    var expected = expectedIconCount();
    var scope = root && root.querySelectorAll ? root : document;

    // a) Containers the theme already renders (cart drawer) — replace the
    //    generic placeholder with the real icons.
    var existing = scope.querySelectorAll('.cart-drawer__payment-icons:not([data-savi-payments])');
    for (var i = 0; i < existing.length; i++) {
      var container = existing[i];
      container.setAttribute('data-savi-payments', 'true');
      if (container.querySelectorAll('svg').length !== expected) {
        container.innerHTML = html;
      }
    }

    // b) Cart page — no container exists, so add one under the trust badges.
    var badges = scope.querySelectorAll('.cart-drawer__trust-badges');
    for (var j = 0; j < badges.length; j++) {
      var row = badges[j];
      if (row.parentElement && row.parentElement.querySelector('.cart-drawer__payment-icons')) continue;
      var added = document.createElement('div');
      added.className = 'cart-drawer__payment-icons';
      added.setAttribute('data-savi-payments', 'true');
      added.innerHTML = html;
      row.insertAdjacentElement('afterend', added);
    }
  }

  function applyAll(root) {
    relabelAll(root);
    fixPaymentIcons(root);
  }

  function start() {
    applyAll(document);

    // The cart drawer and cart summary are re-rendered on every cart change,
    // and product cards arrive lazily (quick-add, infinite scroll), so watch
    // for both new nodes and the buttons toggling their own state.
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var record = records[i];
        if (record.type === 'attributes' && record.target instanceof Element) {
          relabel(record.target);
          continue;
        }
        for (var j = 0; j < record.addedNodes.length; j++) {
          var node = record.addedNodes[j];
          if (node.nodeType === 1) applyAll(node);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributeFilter: ['aria-pressed', 'data-active', 'class'],
    });

    // Cart updates can swap a whole section in one go; a cheap re-check on the
    // theme's own cart event covers anything the observer's node scope misses.
    document.addEventListener('cart:update', function () {
      fixPaymentIcons(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
